<template>
  <div>
    <el-button style="width:100%;" type="secondary" size="small" @click="open">분석 그래프 설정</el-button>
    <w-sliding-popup ref="slidingPopup" title="분석 그래프 설정" top="50px" width="400px" @close="close">
      <div slot="content">
        <div class="mr-b25">
          <div class="title-h4 title-bar">순서정렬</div>
          <draggable v-model="selectedChartTypeData" class="list-drag-box" element="ul" @start="isDraggable = true" @end="isDraggable = false">
            <li v-for="element in selectedChartTypeData" :key="element.chartTypeId">
              <div class="label">{{ element.chartTypeName }}</div>
            </li>
          </draggable>
        </div>
        <div>
          <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
            <div class="title-h4">자원 선택</div>
            <!-- <em style="font-size:12px;">최소 1개에서 최대 5개까지 선택이 가능합니다.</em> -->
            <em style="font-size:12px;">최소 1개이상 선택해야합니다.</em>
          </el-row>
          <el-table-wrapper :columns="rscListTableColumns" :column-default="columnDefault" :data="chartTypeRscData" :pagination="false">
            <template slot-scope="scope" slot="checkboxSlot">
              <el-checkbox v-model="isSelected[scope.$index]" @change="onRscSelectionChange(scope.row, scope.$index, ...arguments)" ref="rscCheckbox"></el-checkbox>
            </template>
          </el-table-wrapper>
        </div>
      </div>
      <div slot="footer">
        <el-button type="solid" size="large" @click="onSaveButtonClick">저장</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { clone } from 'lodash';
import draggable from 'vuedraggable';
import { columnDefault } from '@/constants/table';
import MsgUtil from '@/utils/message';
import commonAPI from '@/api/performance/common';
import { getPerfChartTypeParams } from '@/utils/performance';

export default {
  name: 'WCommonSettingChartTypePopupButton',
  components: {
    draggable,
  },
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isDraggable: false,
      popupVisible: false,
      isSelected: [],
      selectedChartTypeData: [],
      chartTypeRscData: [],
      columnDefault,
      orderbyTableColumns: [
        {
          prop: 'orderbyIndex',
          label: '순서',
          width: 50,
          sortable: false,
          searchable: false,
        },
        {
          prop: 'chartTypeName',
          label: '자원',
          sortable: false,
          searchable: false,
        },
      ],
      rscListTableColumns: [
        {
          label: '선택',
          width: 50,
          scopedSlot: 'checkboxSlot',
          sortable: false,
          searchable: false,
        },
        {
          prop: 'chartTypeName',
          label: '자원',
          sortable: false,
          searchable: false,
        },
      ],
    };
  },
  watch: {
    selectedChartTypeData(value) {
      if (value.length > 0) {
        value.forEach((selectedRscInfo, index) => {
          selectedRscInfo.orderbyIndex = index + 1;
        });
      }
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    /**
     * 계정에 설정된 분석 차트 정보를 조회한다.
     * @author jeee12
     */
    loadData() {
      const params = getPerfChartTypeParams(this.objInfo.obj);
      commonAPI
        .getPerfChartTypeByMgr(params)
        .then((response) => {
          if (response.data.success === true) {
            this.selectedChartTypeData = response.data.data;
            this.loadPerfChartTypeData(params);
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '분석 그래프 정보', false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '분석 그래프 정보', false));
          throw new Error(e);
        });
    },
    /**
     * 장비의 분석 차트 정보를 조회한다.
     * @param  {[type]} params [description]
     */
    loadPerfChartTypeData(params) {
      commonAPI
        .getRscListForPerfChartType(params)
        .then((response) => {
          if (response.data.success === true) {
            this.chartTypeRscData = response.data.data;
            if (this.selectedChartTypeData.length > 0) this.setCheckedChartTypeData();
          } else {
            this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '분석 그래프 정보', false));
          }
        })
        .catch((e) => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.VIEW, '분석 그래프 정보', false));
          throw new Error(e);
        });
    },
    /**
     * 분석 그래프 설정 자원 선택 체크박스 checked 초기화
     * @author jeee12
     */
    setCheckedChartTypeData() {
      const selected = [];
      this.chartTypeRscData.forEach((data) => {
        const findIndex = this.selectedChartTypeData.findIndex((findData) => findData.chartTypeId === data.chartTypeId);
        if (findIndex > -1) {
          selected.push(true);
        } else {
          selected.push(false);
        }
      });
      this.isSelected = selected;
    },
    /**
     * 자원선택 테이블 > 자원 선택/해제 시
     * @author jeee12
     * @param  {Object} row          선택한 row
     * @param  {Integer} rowIndex     선택한 row Index
     * @param  {Boolean} checkedValue 선택/해제
     */
    onRscSelectionChange(row, rowIndex, checkedValue) {
      const index = this.selectedChartTypeData.findIndex((data) => data.chartTypeId === row.chartTypeId);

      // 2019. 11. 05 - SKCC - 분석 그래프 최대 개수에 대한 제한 해제 요청 - 사이트에서 부하관련 이슈 생길 시 대응하도록 조치예정 (Song)
      // if (index === -1 && this.selectedChartTypeData.length === 5) {
      //   this.$message(MsgUtil.getCustomResultMsgData('최대 5개까지 선택이 가능합니다.'));
      //   this.isSelected[rowIndex] = false;
      //   return;
      // }

      if (index > -1 && this.selectedChartTypeData.length === 1) {
        this.$message(MsgUtil.getCustomResultMsgData('최소 1개이상 선택해야합니다.'));
        this.isSelected[rowIndex] = true;
        return;
      }

      if (checkedValue && index === -1) {
        const rscInfo = clone(row);
        this.selectedChartTypeData.push(rscInfo);
      } else if (!checkedValue && index > -1) {
        this.selectedChartTypeData.splice(index, 1);
      }
    },
    /**
     * 저장 버튼 클릭
     * @author jeee12
     */
    onSaveButtonClick() {
      this.$confirm(...MsgUtil.getBasicConfirmData('분석 그래프 설정을 저장'))
        .then(() => {
          const updateList = [];
          this.selectedChartTypeData.forEach((data) => {
            const selectedChartType = {
              managetypeId: data.managetypeId,
              chartTypeId: data.chartTypeId,
              managetypeKey: data.managetypeKey,
              objtypeId: data.objtypeId,
              orderbyIndex: data.orderbyIndex,
            };
            updateList.push(selectedChartType);
          });

          commonAPI.updatePerfChartTypeMgrList(updateList).then((response) => {
            if (response.data.success === true) {
              this.$message(MsgUtil.getResultMsgData(MsgUtil.action.SAVE, '분석 그래프 설정', true));
              this.close();
            } else {
              this.$message(MsgUtil.getResultMsgData(MsgUtil.action.SAVE, '분석 그래프 설정', false));
            }
          });
        })
        .catch(() => {
          this.$message(MsgUtil.getResultMsgData(MsgUtil.action.CANCEL, '분석 그래프 설정', true));
        });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      // 선택된 자원, checkbox 초기화
      this.selectedChartTypeData = [];
      this.isSelected = [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/CommonSettingChartTypePopupButton.vue